import React from 'react';

import { Icon28HelpCircleOutline } from '@vkontakte/icons';
import {
  Button,
  Spacing,
  Text,
  Title,
} from '@vkontakte/vkui';

import styles from './index.module.css';
import { SelfPredictionBoxProps } from './types';

export const SelfPredictionBox: React.FC<SelfPredictionBoxProps> = ({ handleGetMyTemperamentClick, goToAboutUs }) => {
  return (
    <div className={styles.optionContainer}>
      <div className={styles.upperBox}>
        <Title level="2" className={styles.title}>
                  Узнать свой<br/>профессиональный тип
        </Title>
        <Spacing size={8} />
        <Text className={styles.text}>
                  Проверьте бесплатно с помощью искусственного интеллекта, что ваша страница говорит о Вас
        </Text>
        <Spacing size={45} />
      </div>
      <Button
        onClick={handleGetMyTemperamentClick}
        mode="primary"
        size="l"
      >
                Узнать профессиональный тип
      </Button>
      <Spacing size={42} />
      <Button
        onClick={goToAboutUs}
        before={<Icon28HelpCircleOutline />}
        mode="tertiary"
        size="l"
      >
                О проекте
      </Button>
    </div>);
};
